import { render } from "./MetricWidget.vue?vue&type=template&id=3a98d012"
import script from "./MetricWidget.vue?vue&type=script&lang=js"
export * from "./MetricWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__